import { defineSlotRecipe } from '@chakra-ui/react';

export const cardSlotRecipe = defineSlotRecipe({
  className: 'chakra-card',
  slots: ['root', 'header', 'body', 'footer', 'title', 'description'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      minWidth: '0',
      wordWrap: 'break-word',
      borderRadius: 'l3',
      color: 'fg',
      textAlign: 'start',
    },
    title: {
      fontWeight: 'bold',
    },
    description: {
      color: 'fg.muted',
      fontSize: 'sm',
    },
    header: {
      paddingInline: 'var(--card-padding)',
      paddingTop: 'var(--card-padding)',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5',
    },
    body: {
      padding: 'var(--card-padding)',
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
    },
    footer: {
      display: 'flex',
      alignItems: 'center',
      gap: '2',
      paddingInline: 'var(--card-padding)',
      paddingBottom: 'var(--card-padding)',
    },
  },
  variants: {
    size: {
      sm: {
        root: {
          '--card-padding': 'spacing.4',
        },
        title: {
          textStyle: 'md',
        },
      },
      md: {
        root: {
          '--card-padding': 'spacing.6',
        },
        title: {
          textStyle: 'lg',
        },
      },
      lg: {
        root: {
          '--card-padding': 'spacing.7',
        },
        title: {
          textStyle: 'xl',
        },
      },
    },
    gradient: {
      true: {
        root: {
          // background: linear-gradient(104.73deg, #D8C7B2 -33.82%, #FCF7F1 8.98%, #FCF7F1 66.98%, #D8C7B2 129.51%);
          bgGradient:
            'linear-gradient(105deg, {colors.cream.dark} -30%, {colors.cream} 10%, {colors.cream} 70%, {colors.cream.dark} 130%)',
        },
      },
    },
    variant: {
      elevated: {
        root: {
          bg: 'bg.panel',
          boxShadow: 'md',
        },
      },
      outline: {
        root: {
          bg: 'bg.panel',
          borderWidth: '1px',
          borderColor: 'border',
        },
      },
      subtle: {
        root: {
          bgColor: 'cream',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'subtle',
    size: 'md',
  },
});
